(function () {
    "use strict";

    angular
        .module("app")
        .directive("nrfColorSearchHelp", ["SearchFactory", nrfColorSearchHelp]);

    function nrfColorSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {
                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.nrfColorKey = "";
                        scope.nrfColorName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.nrfColorName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }
                    var modalSearch = searchFactory.nrfColorSearch(function (nrfColor) {
                        scope.nrfColorKey = nrfColor ? nrfColor.NrfColorKey : "";
                        scope.nrfColorName = nrfColor ? nrfColor.NrfColorName : "";

                        scope.displayValue = scope.nrfColorName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.nrfColorName;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("nrfColorName", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { nrfColorKey: "=", nrfColorName: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

